<div class="item" style="height: calc(100vh - 400px); position: relative">
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="table-container">
    <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
      <colgroup>
        <col *ngFor="let col of tableHeader" [width]="col.width"/>
      </colgroup>
      <thead>
        <tr>
          <th *ngFor="let header of tableHeader" [sortable-column]="header.value"> 
            <div>{{header.name}}</div>
          </th>
        </tr>
      </thead>
    </table>
    <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-data'"> <i class="material-icons">inventory_2</i>
      <div>No Data</div>
    </div>
    <div class="table-body" *ngIf="determineElementToShow() === 'normal'">
      <table>
        <colgroup>
          <col *ngFor="let col of tableHeader" [width]="col.width"/>
        </colgroup>
        <tbody>
          <tr *ngFor="let subCategory of subCategoryList">
            <td>{{subCategory?.name}}</td>
            <td> 
              <div style="color:rgba(0, 0, 0, 0.6)">{{subCategory?.description}}</div>
            </td>
            <td>
              <div class="more-content v-center" #actionMenus [id]="'target-'+ subCategory.incident_type_category_id" (mouseover)="setMorePosition(subCategory.incident_type_category_id)">
                <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(subCategory)">
                  <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                </div>
                <div class="more" [class.show]="subCategory.isShowMenu" [id]="'target-more-'+subCategory.incident_type_category_id">
                  <div class="more-item row" (click)="openEditDialog($event, subCategory)">
                    <div>Edit</div>
                  </div>
                  <div class="more-item row txt-danger" (click)="openDeleteDialog($event, subCategory)">
                    <div>Delete</div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>